import type { IntlShape } from 'react-intl';

import type {
  FilterValues,
  SetValueProps,
} from '@src/components/FilterDropDown/FilterDropDown.interfaces';
import { translateString } from '@src/util/intl/translateString';

export const JOBS_LIST_FILTER_FIELDS = {
  NAME: 'name',
} as const;

export interface JobsListFilterState {
  name: string;
}

export const INIT_JOBS_LIST_FILTERS: FilterValues = {
  [JOBS_LIST_FILTER_FIELDS.NAME]: {
    value: '',
    label: translateString('position.job.filter'),
    valueType: 'string',
  },
};

export const filterValuesToJobsListFilters = (values: FilterValues): JobsListFilterState => {
  const name = String(values[JOBS_LIST_FILTER_FIELDS.NAME]?.value ?? '').trim();

  return { name };
};

export const buildJobsListFilterSetValueProps = (
  key: string,
  value: unknown,
  intl: IntlShape,
): SetValueProps => {
  switch (key) {
    case JOBS_LIST_FILTER_FIELDS.NAME:
      return {
        key,
        value: String(value ?? ''),
        label: intl.formatMessage({ id: 'position.job.filter' }),
        valueTranslated: String(value ?? ''),
        valueType: 'string',
      };
    default:
      return { key, value: value as SetValueProps['value'], valueType: 'string' };
  }
};
